"use client"
import styled from "styled-components"
import { Moon, Sun } from "react-feather"
import Logo from "../ui/Logo"

const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 50;
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.border};
  background-color: ${(props) => props.theme.background};
  backdrop-filter: blur(8px);
`

const HeaderContainer = styled.div`
  display: flex;
  height: 64px;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  max-width: 1400px;
  margin: 0 auto;
`

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const LogoText = styled.span`
  font-weight: bold;
  display: none;
  
  @media (min-width: 640px) {
    display: inline-block;
  }
`

const NavContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const Nav = styled.nav`
  display: none;
  align-items: center;
  gap: 24px;
  
  @media (min-width: 768px) {
    display: flex;
  }
`

const NavLink = styled.a`
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s;
  color: ${(props) => props.theme.text};
  
  &:hover {
    color: ${(props) => props.theme.primary};
  }
`

const ThemeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.border};
  background-color: transparent;
  color: ${(props) => props.theme.text};
  cursor: pointer;
  
  &:hover {
    background-color: ${(props) => props.theme.accent};
  }
`

const ConnectButton = styled.button`
  display: none;
  align-items: center;
  height: 36px;
  padding: 0 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid ${(props) => props.theme.border};
  background-color: transparent;
  color: ${(props) => props.theme.text};
  cursor: pointer;
  
  &:hover {
    background-color: ${(props) => props.theme.accent};
  }
  
  @media (min-width: 768px) {
    display: flex;
  }
`

function DashboardHeader({ toggleTheme, isDarkMode }) {
  return (
    <Header>
      <HeaderContainer>
        <LogoContainer>
          <Logo size={24} />
          <LogoText>AntsCoin</LogoText>
        </LogoContainer>

        <NavContainer>
          <Nav>
            <NavLink href="#">Markets</NavLink>
            <NavLink href="#">Trading</NavLink>
            <NavLink href="#">Analytics</NavLink>
            <NavLink href="#">News</NavLink>
          </Nav>

          <ThemeButton onClick={toggleTheme}>{isDarkMode ? <Sun size={18} /> : <Moon size={18} />}</ThemeButton>

          <ConnectButton>Connect Wallet</ConnectButton>
        </NavContainer>
      </HeaderContainer>
    </Header>
  )
}

export default DashboardHeader

